module.exports = __webpack_public_path__ + "static/media/sateliteViewzz.7a31a61f.png";